import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getBusinessUnitDetails,
  getAssignUserList,
} from "./redux/businessUnitSlice";
import BusinessUnitViewDetails from "./components/businessUnitViewDetails";
import BusinessUnitViewCompanyList from "./components/businessUnitViewCompanyList";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";

export default function BusinessUnitView() {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getBusinessUnitDetails(id));
    }
  }, [dispatch, id]);

  return (
    <StepperContentHolder>
      <BusinessUnitViewDetails />
      <BusinessUnitViewCompanyList />
    </StepperContentHolder>
  );
}
